

import * as React from 'react';
import cn from 'classnames';

interface LoadingSpinnerProps {
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className }) => (
  <i className={cn('glyphicon', 'glyphicon-refresh', 'glyphicon-spin', className)} />
);

export default LoadingSpinner;
